// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusBottomrightOutlinedSvg from "@fishx/icons-svg/es/asn/RadiusBottomrightOutlined";
import FishxIcon from '../components/FishxIcon';

var RadiusBottomrightOutlined = function RadiusBottomrightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomrightOutlinedSvg
  }));
};

RadiusBottomrightOutlined.displayName = 'RadiusBottomrightOutlined';
export default React.forwardRef(RadiusBottomrightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RadiusBottomrightOutlined.js
// module id = 3959
// module chunks = 0